import { render } from "./BlockedRecipients.vue?vue&type=template&id=50285268"
import script from "./BlockedRecipients.vue?vue&type=script&lang=js"
export * from "./BlockedRecipients.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./BlockedRecipients.vue?vue&type=style&index=0&id=50285268&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__